import React, { useState, useRef, useEffect } from "react";
import { PARAMETER_MAP } from "../../util/PARAMETER_MAP";

export default function ParamAutocomplete({
  selectedParam,
  onSelect,
  allowedParams = null
}) {
  const [search, setSearch] = useState("");
  const [open, setOpen] = useState(false);

  const wrapperRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () =>
      document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    if (!selectedParam) {
      setSearch("");
      return;
    }

    const meta = PARAMETER_MAP[selectedParam];

    if (meta) {
      setSearch(`${selectedParam} - ${meta.name}`);
    }
  }, [selectedParam]);

  const params = Object.entries(PARAMETER_MAP)
    .filter(([id]) => {
      if (!allowedParams) return true;
      return allowedParams.includes(Number(id));
    })
    .filter(([id, meta]) => {
      const text = `${id} ${meta.code} ${meta.name}`.toLowerCase();
      return text.includes(search.toLowerCase());
    });

  return (
    <div ref={wrapperRef} className="param-autocomplete">
      <input
        className="param-autocomplete-input"
        value={search}
        onChange={(e) => {
          const value = e.target.value;

          setSearch(value);
          setOpen(true);

          if (!value) {
            onSelect("");
          }
        }}
        onFocus={() => setOpen(true)}
        placeholder="Buscar variável..."
      />

      {open && (
        <div className="param-autocomplete-dropdown">
          {params.length === 0 && (
            <div className="param-autocomplete-empty">
              Nenhum resultado
            </div>
          )}

          {params.map(([id, meta]) => (
            <div
              key={id}
              className="param-autocomplete-item"
              onClick={() => {
                onSelect(Number(id));
                setSearch(`${id} — $${meta.name}`);
                setOpen(false);
              }}
            >
              <span className="param-autocomplete-id">{id}</span> —{" "}
              {meta.name}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
